const adminCoursesRoutes = [
    { path: 'packages', name: 'packages', component: () => import('pages/sot.bot.admin/courses-packages/infinityTable/PackagesIndex.vue') },
    { path: 'courses', name: 'courses', component: () => import('pages/sot.bot.admin/courses-packages/infinityTable/CPIndex.vue') },
    { path: 'courses/:packageId', name: 'packageCourses', component: () => import('pages/sot.bot.admin/courses-packages/infinityTable/CPIndex.vue') },

    {
        path: 'courses/:packageId/:id',
        name: 'courseAdmin',
        component: () => import('pages/sot.bot.admin/courses/CoursesIndex.vue'),
        children: [
            {
                path: 'participants',
                redirect: (to) => ({
                    name: 'courseParticipants',
                    params: { ...to.params, subsection: 'teachers' },
                }),
            },
            {
                path: 'participants/:subsection/:tab?',
                name: 'courseParticipants',
                component: { render: () => null },
            },
            {
                path: 'settings',
                redirect: (to) => ({
                    name: 'courseSettings',
                    params: { ...to.params, subsection: 'main' },
                }),
            },
            {
                path: 'settings/:subsection/:tab?',
                name: 'courseSettings',
                component: { render: () => null },
            },
            {
                path: 'digit-trace/:subsection?',
                name: 'course-digit-trace',
                component: { render: () => null },
            },
            {
                path: 'site',
                redirect: (to) => ({
                    name: 'courseSite',
                    params: { ...to.params, subsection: 'card' },
                }),
            },
            {
                path: 'site/:subsection',
                name: 'courseSite',
                component: { render: () => null },
            },
            // Остальные разделы курса (плюс редирект для обратной совместимости); sectionId — объект раздела, например ответ в «Заданиях»
            {
                path: ':section?/:sectionId?',
                name: 'courseSection',
                component: { render: () => null },
                beforeEnter: (to) => {
                    const tab = to.query.tab;
                    const { packageId, id, section } = to.params;

                    // Обратная совместимость с ?tab=X
                    if (tab) {
                        const query = { ...to.query };
                        delete query.tab;

                        const participantsTabs = ['teachers', 'orgs', 'partners_settings', 'rating'];

                        if (participantsTabs.includes(tab)) {
                            return { path: `/jM5a-1Pq8/courses/${packageId}/${id}/participants/${tab}`, query, replace: true };
                        }

                        // Отдельной панели add_chat нет — рендерится через edit_chat с chatId=add.
                        if (tab === 'add_chat') {
                            return { path: `/jM5a-1Pq8/courses/${packageId}/${id}/edit_chat`, query: { ...query, id: 'add' }, replace: true };
                        }

                        return { path: `/jM5a-1Pq8/courses/${packageId}/${id}/${tab}`, query, replace: true };
                    }

                    // add_chat как path-сегмент тоже перенаправляем в edit_chat с id=add,
                    // чтобы старые ссылки/закладки продолжали работать.
                    if (section === 'add_chat') {
                        return { path: `/jM5a-1Pq8/courses/${packageId}/${id}/edit_chat`, query: { ...to.query, id: 'add' }, replace: true };
                    }

                    // Если раздел не указан, редиректим на info
                    if (!section) {
                        return { path: `/jM5a-1Pq8/courses/${packageId}/${id}/info`, query: to.query, replace: true };
                    }

                    return true;
                },
            },
        ],
    },
];

export default adminCoursesRoutes;
